import { useEffect, useState } from 'react';

import { captureException } from '@sentry/react';

import { API_ENDPOINTS } from 'common/constants';

import axios from 'common/lib/axios';

import { Campaign } from 'features/apply/utils/api';

export const DEFAULT_CAMPAIGN: Campaign = {
  pageHeader: 'Join as a cleaner',
  payRateDescription: 'Earn £13.00-£14.00 per hour + tips'
};

export function useRecruitmentCampaign(campaignCode: string | null) {
  const [campaign, setCampaign] = useState<Campaign>();

  // On load, fetch the campaign for this applicant from the backend.
  useEffect(() => {
    if (!!campaignCode) {
      (async () => {
        await getCampaignInformation(campaignCode);
      })();
    } else {
      setCampaign(DEFAULT_CAMPAIGN);
    }
  }, [campaignCode]);

  /**
   * Update state with the latest appointment in the backend for this applicant
   */
  const getCampaignInformation = async (campaignCode: string): Promise<void> => {
    try {
      const { data }: { data: Campaign } = await axios.get<Campaign>(API_ENDPOINTS.CAMPAIGN_INFORMATION(campaignCode));
      if (data) {
        setCampaign(data);
      }
    } catch (e) {
      captureException(e);
      setCampaign(DEFAULT_CAMPAIGN);
    }
  };

  return { campaign };
}
